<!-- Chat Section -->
<div class="rounded-lg border-0">
  <div class="text-center p-3 rounded-top border-0 d-flex justify-content-between align-items-center mt-0">
    <div class="d-flex align-items-center">
      <i class='bx bxs-user-circle fs-3 text-primary me-2 cursor-pointer'></i>
      <p class="text-xs mb-0 text-dark fw-bold">Live Chat with Lead {{ $route.query.lead_name }}</p>
    </div>
  </div>

  <div class="position-relative p-1 rounded-lg glass-card bg-transparent card-body-h">
    <div class="bg-light rounded-5 m-3 position-absolute top-0 start-0 end-0 bottom-0 z-0"></div>

    <div class="position-relative h-100 d-flex flex-column justify-content-between">
      <div class="p-3 scroll-container-crm" ref="scrollContainer">
        <div v-if="Object.keys(lead_messages).length === 0" class="text-center text-muted small">
          No messages yet. Start the chat below.
        </div>

        <div v-for="(messages, date) in lead_messages" :key="date">
          <!-- Date Header -->
          <div class="text-center text-muted text-xs fw-bold my-2">{{ date }}</div>

          <!-- Messages -->
          <div v-for="msg in messages" :key="msg.id"
               class="mb-3 d-flex flex-column"
               :class="{ 'align-items-end': msg.is_superuser, 'align-items-start': !msg.is_superuser }">

            <!-- Sender Label -->
            <span class="text-xxs fw-semibold mb-1"
                  :class="{ 'text-end': msg.is_superuser, 'text-start': !msg.is_superuser }">
              {{ msg.is_superuser ? 'You' : 'Lead' }}
            </span>

            <!-- Message Bubble -->
            <div
              v-if="msg.message || msg.attachment_url"
              :class="[
                  'message-bubble',
                  (is_image(msg.attachment_name) && !msg.message)
                    ? 'image-only'
                    : 'p-3 rounded-pill shadow-sm text-xxs ' +
                      (msg.is_superuser ? 'primary-color text-dark'
                                        : 'custom-header text-white')
              ]">

              <span v-if="msg.message">{{ msg.message }}</span>
              <template v-if="msg.attachment_url">
                <br v-if="msg.message">

                <img  v-if="is_image(msg.attachment_name)"
                      :src="msg.attachment_url"
                      class="bubble-img"
                      @click.prevent="open_attachment(msg)"/>

                <a   v-else
                    href="#"
                    data-bs-toggle="modal" data-bs-target="#attachment_viewer"
                    @click.prevent="open_attachment(msg)"
                    :class="msg.is_superuser ? 'text-dark' : 'text-white'"
                    class="text-decoration-underline d-inline-block mt-1">
                    {{ msg.attachment_name }}
                </a>
              </template>
            </div>

            <!-- Timestamp -->
            <small class="text-muted mt-1 text-xxs fw-bold"
                   :class="{ 'text-end': msg.is_superuser, 'text-start': !msg.is_superuser }">
              {{ msg.time }}
            </small>
          </div>
        </div>
      </div>

      <!-- Message Input with Inline Preview -->
      <div class="position-relative">
        <!-- Preview Modal -->
        <div v-if="show_preview && preview_url && selected_file" class="mb-2 p-3 bg-white border rounded-3 shadow-sm">
          <div class="d-flex align-items-start justify-content-between">
            <div class="d-flex align-items-center flex-grow-1">
            </div>

            
          </div>

          <!-- Document Preview -->
          <div v-if="is_previewable && !is_image(selected_file.name)" 
               class="mt-3 border rounded overflow-hidden ratio ratio-1x1 h-500 shadow-lg">
            <iframe :src="preview_url" 
                    class="w-100 h-100 overflow-auto"
                    frameborder="0"></iframe>
          </div>
        </div>

        <!-- Text Input with File Chip Inside -->
        <div class="position-relative">
          <input
            type="text"
            class="form-control rounded-pill p-3 text-xs border border-1 border-black"
            :class="{
              'ps-5': selected_file,
              'pe-4': true,
              'rounded-pill': true,
              'text-xs': true
            }"

            v-model="admin_message"
            :placeholder="selected_file ? '' : 'Type your message...'"
            @keyup.enter="send_admin_message"
          />

          <!-- File Chip inside input (left side) -->
          <div v-if="selected_file" 
               class="position-absolute start-0 top-50 translate-middle-y ms-2 d-flex align-items-center bg-white border rounded px-2 py-1 cursor-pointer mw-100"
              
               @click="show_preview = !show_preview">
            <i class="bi bi-file-earmark-text text-danger me-1"></i>
            <span class="text-xxs text-truncate me-1 d-inline-block" > {{ selected_file.name }} </span>

            <span class="text-xxs text-muted">{{ format_file_size(selected_file.size) }}</span>
            <button type="button" 
                    class="btn-close btn-sm ms-1 text-xxs"
                    @click.stop="clear_file"
                    aria-label="Remove attachment"></button>

          </div>

          <!-- Icons inside the input (right side) -->
          <div class="position-absolute end-0 top-50 translate-middle-y d-flex gap-2 me-3">
            <!-- Attachment Icon -->
            <i class="btn-sm btn-primary-dark text-dark rounded-lg bi bi-paperclip fs-6 mt-1" 
               role="button" 
               @click="$refs.file_input.click()"></i>

            <!-- Send Icon -->
            <span class="btn-sm btn-primary-dark text-dark rounded-lg fs-6 mt-1" 
                  role="button" 
                  @click="send_admin_message">➤</span>
          </div>

          <!-- Hidden file input -->
          <input
            type="file"
            ref="file_input"
            class="d-none"
            @change="handle_file_change"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Attachment Viewer Modal -->
<teleport to="body">
  <div class="modal fade" id="attachment_viewer" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">

        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs mb-0">{{ viewer_name }}</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body p-0 overflow-auto doc-viewer-body">

          <img v-if="is_image(viewer_name)"
               :src="viewer_url"
               class="img-fluid w-100 rounded-0" />

          <iframe v-else
            :src="viewer_url"
            class="w-100 h-100 border-0 file-viewer-frame">
          </iframe>
        </div>

      </div>
    </div>
  </div>
</teleport>